import OnOffSwitch from './OnOffSwitch';

export default function RedirectSubdomainPicker({
  redirectSubdomain,
  setRedirectSubdomain,
  blogId,
  domain,
}) {
  return (
    <OnOffSwitch
      value={redirectSubdomain}
      setValue={setRedirectSubdomain}
      title="Redirect subdomain"
      description={`Redirect ${blogId}.truvvl.blog to ${domain}`}
      label="Redirect subdomain"
    />
  );
}
